import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

export type Lang = 'fr' | 'en';

export const translations = {
  fr: {
    flag: '🇫🇷',
    searchPlaceholder: 'Rechercher par ID ou nom...',
    typeAll: 'Tous types',
    typeUsage: 'Usage Interne',
    typeStock: 'Stock',
    stockPlaceholder: 'Stock ≥ ...',
    gmcceAll: 'Tous GMC CE',
    prixGt: 'Prix de vente client final ≥',
    prixLt: 'Prix de vente client final ≤',
    prixPlaceholder: 'Prix (en euros)',
    badgeUsage: 'Usage Interne',
    // ...champs catalogue/détail...
    articleSheetId: 'Référence fournisseur',
    label: 'Label',
    gmcce: 'GMC CE',
    gmc1: 'GMC1',
    gmc2: 'GMC2',
    gmc3: 'GMC3',
    gmc4: 'GMC4',
    longueur: 'Longueur',
    largeur: 'Largeur',
    hauteur: 'Hauteur',
    poids: 'Poids',
    itg: 'Itg',
    its: 'Its',
    pid: 'Pid',
    mig: 'Mig',
    manutanLink: 'Lien Manutan',
    availableStock: 'Stock disponible à la vente',
    totalStock: 'Total stock',
    confirmedReserved: 'Réservé confirmé',
    temporaryReserved: 'Réservé temporaire',
    pending: 'En attente de reconditionnement',
    usageInterne: 'Usage Interne',
    closeZoom: 'Fermer la photo zoomée',
    closeDrawer: 'Fermer le détail',
    prevPhoto: 'Photo précédente',
    nextPhoto: 'Photo suivante',
    noPhoto: 'Photo absente',
    descriptif: 'Détails',
    pdvFinal: 'Prix de vente client final',
    pdvFiliale: 'Prix d’achat filiale',
    loginTitle: 'Connexion',
    loginEmail: 'Email',
    loginPassword: 'Mot de passe',
    loginBtn: 'Se connecter',
    loginLoading: 'Connexion...',
    loginError: 'Identifiants invalides',
    loginErrorNetwork: 'Erreur de connexion',
    loginCreate: 'Créer un compte',
    lockerTitle: 'Accès création de compte',
    lockerPassword: 'Mot de passe de protection',
    lockerBtn: 'Valider',
    lockerLoading: 'Vérification...',
    lockerError: 'Mot de passe incorrect',
    signupTitle: 'Créer un compte',
    signupUsername: "Nom d'utilisateur",
    signupEmail: 'Email',
    signupPassword: 'Mot de passe',
    signupBtn: 'Créer le compte',
    signupLoading: 'Création...',
    signupError: 'Erreur lors de la création du compte',
    signupErrorNetwork: 'Erreur de connexion',
    ht: "HT"
    ,
    accountLabel: 'Mon compte'
    ,
    accountTooltip: 'En cours de construction'
    ,
    openSpec: 'Exporter en PDF',
    loadingPdf: 'Chargement...',
    tabAvailable: 'Stock disponible',
    tabPending: 'En attente de reconditionnement',
    tabOthers: 'Autres',
    // Mon Compte
    myAccountTitle: 'Mon Compte',
    backToCatalogue: 'Retour au catalogue',
    currentUsername: 'Nom d\'utilisateur actuel',
    newUsername: 'Nouveau nom d\'utilisateur',
    updateUsernameBtn: 'Mettre à jour le nom',
    updateUsernameLoading: 'Mise à jour...',
    updateUsernameSuccess: 'Nom d\'utilisateur mis à jour avec succès',
    updateUsernameError: 'Erreur lors de la mise à jour',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    updatePasswordBtn: 'Mettre à jour le mot de passe',
    updatePasswordLoading: 'Mise à jour...',
    updatePasswordSuccess: 'Mot de passe mis à jour avec succès',
    updatePasswordError: 'Erreur lors de la mise à jour',
    passwordRules: 'Le mot de passe doit :',
    passwordRuleLength: 'Contenir au moins 12 caractères',
    passwordRuleUppercase: 'Contenir des majuscules',
    passwordRuleLowercase: 'Contenir des minuscules',
    passwordRuleNumber: 'Contenir des chiffres',
    passwordRuleSymbol: 'Contenir des symboles',
    passwordRuleUsername: 'Ne pas contenir votre nom d\'utilisateur',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordInvalid: 'Le mot de passe ne respecte pas les règles',
    // Forgot Password
    forgotPasswordLink: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Réinitialisation du mot de passe',
    forgotPasswordEmailLabel: 'Adresse email',
    forgotPasswordEmailPlaceholder: 'Entrez votre adresse email',
    forgotPasswordEmailBtn: 'Recevoir le code',
    forgotPasswordEmailLoading: 'Envoi en cours...',
    forgotPasswordEmailSuccess: 'Un code à 6 chiffres a été envoyé à votre adresse email',
    forgotPasswordEmailError: 'Erreur lors de l\'envoi du code',
    forgotPasswordCodeTitle: 'Code de vérification',
    forgotPasswordCodeLabel: 'Code à 6 chiffres',
    forgotPasswordCodePlaceholder: 'Entrez le code reçu par email',
    forgotPasswordCodeSent: 'Un code à 6 chiffres a été envoyé à',
    forgotPasswordCodeSpam: 'Pensez à vérifier vos spams',
    forgotPasswordCodeBtn: 'Valider le code',
    forgotPasswordCodeLoading: 'Vérification...',
    forgotPasswordCodeError: 'Code invalide',
    forgotPasswordNewTitle: 'Nouveau mot de passe',
    forgotPasswordNewDescription: 'Créez un nouveau mot de passe pour',
    forgotPasswordNewLabel: 'Nouveau mot de passe',
    forgotPasswordNewConfirmLabel: 'Confirmer le mot de passe',
    forgotPasswordNewBtn: 'Réinitialiser le mot de passe',
    forgotPasswordNewLoading: 'Réinitialisation...',
    forgotPasswordNewSuccess: 'Mot de passe réinitialisé avec succès',
    forgotPasswordNewError: 'Erreur lors de la réinitialisation'
  },
  en: {
    flag: '🇬🇧',
    searchPlaceholder: 'Search by ID or name...',
    typeAll: 'All types',
    typeUsage: 'Internal Use',
    typeStock: 'Stock',
    stockPlaceholder: 'Stock ≥ ...',
    gmcceAll: 'All GMC CE',
    prixGt: 'End customer sale price ≥',
    prixLt: 'End customer sale price ≤',
    prixPlaceholder: 'Price (in euros)',
    badgeUsage: 'Internal Use',
    // ...champs catalogue/détail...
    articleSheetId: 'Supplier reference',
    label: 'Label',
    gmcce: 'GMC CE',
    gmc1: 'GMC1',
    gmc2: 'GMC2',
    gmc3: 'GMC3',
    gmc4: 'GMC4',
    longueur: 'Length',
    largeur: 'Width',
    hauteur: 'Height',
    poids: 'Weight',
    itg: 'Itg',
    its: 'Its',
    pid: 'Pid',
    mig: 'Mig',
    manutanLink: 'Manutan Link',
    availableStock: 'Stock available for sale',
    totalStock: 'Total stock',
    confirmedReserved: 'Confirmed reserved',
    temporaryReserved: 'Temporary reserved',
    pending: 'Pending Refurbishment',
    usageInterne: 'Internal Use',
    closeZoom: 'Close zoomed photo',
    closeDrawer: 'Close details',
    prevPhoto: 'Previous photo',
    nextPhoto: 'Next photo',
    noPhoto: 'No photo',
    descriptif: 'Details',
    pdvFinal: 'End customer sale price',
    pdvFiliale: 'Subsidiary purchase price',
    loginTitle: 'Login',
    loginEmail: 'Email',
    loginPassword: 'Password',
    loginBtn: 'Sign in',
    loginLoading: 'Signing in...',
    loginError: 'Invalid credentials',
    loginErrorNetwork: 'Connection error',
    loginCreate: 'Create an account',
    lockerTitle: 'Account creation access',
    lockerPassword: 'Protection password',
    lockerBtn: 'Validate',
    lockerLoading: 'Checking...',
    lockerError: 'Incorrect password',
    signupTitle: 'Create an account',
    signupUsername: 'Username',
    signupEmail: 'Email',
    signupPassword: 'Password',
    signupBtn: 'Create account',
    signupLoading: 'Creating...',
    signupError: 'Error while creating account',
    signupErrorNetwork: 'Connection error',
    ht: 'excl. VAT',
    accountLabel: 'My account',
    accountTooltip: 'Under construction'
    ,
    openSpec: 'Export PDF',
    loadingPdf: 'Loading...',
    tabAvailable: 'Available stock',
    tabPending: 'Pending Refurbishment',
    tabOthers: 'Others',
    // My Account
    myAccountTitle: 'My Account',
    backToCatalogue: 'Back to catalogue',
    currentUsername: 'Current username',
    newUsername: 'New username',
    updateUsernameBtn: 'Update username',
    updateUsernameLoading: 'Updating...',
    updateUsernameSuccess: 'Username updated successfully',
    updateUsernameError: 'Error updating username',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    updatePasswordBtn: 'Update password',
    updatePasswordLoading: 'Updating...',
    updatePasswordSuccess: 'Password updated successfully',
    updatePasswordError: 'Error updating password',
    passwordRules: 'Password must:',
    passwordRuleLength: 'Be at least 12 characters long',
    passwordRuleUppercase: 'Contain uppercase letters',
    passwordRuleLowercase: 'Contain lowercase letters',
    passwordRuleNumber: 'Contain numbers',
    passwordRuleSymbol: 'Contain symbols',
    passwordRuleUsername: 'Not contain your username',
    passwordMismatch: 'Passwords do not match',
    passwordInvalid: 'Password does not meet requirements',
    // Forgot Password
    forgotPasswordLink: 'Forgot password?',
    forgotPasswordTitle: 'Password Reset',
    forgotPasswordEmailLabel: 'Email address',
    forgotPasswordEmailPlaceholder: 'Enter your email address',
    forgotPasswordEmailBtn: 'Receive code',
    forgotPasswordEmailLoading: 'Sending...',
    forgotPasswordEmailSuccess: 'A 6-digit code has been sent to your email address',
    forgotPasswordEmailError: 'Error sending code',
    forgotPasswordCodeTitle: 'Verification code',
    forgotPasswordCodeLabel: '6-digit code',
    forgotPasswordCodePlaceholder: 'Enter the code received by email',
    forgotPasswordCodeSent: 'A 6-digit code has been sent to',
    forgotPasswordCodeSpam: 'Remember to check your spam folder',
    forgotPasswordCodeBtn: 'Validate code',
    forgotPasswordCodeLoading: 'Verifying...',
    forgotPasswordCodeError: 'Invalid code',
    forgotPasswordNewTitle: 'New password',
    forgotPasswordNewDescription: 'Create a new password for',
    forgotPasswordNewLabel: 'New password',
    forgotPasswordNewConfirmLabel: 'Confirm password',
    forgotPasswordNewBtn: 'Reset password',
    forgotPasswordNewLoading: 'Resetting...',
    forgotPasswordNewSuccess: 'Password reset successfully',
    forgotPasswordNewError: 'Error resetting password'
  },
};

export const gmccelist = [
      {fr:'Armoire basse', en:"Low cabinet"},
      {fr:'Armoire haute', en:"High cabinet"},
      {fr:'Bureau droit simple', en:"Simple straight desk"},
      {fr:'Caisson', en:"Pedestal"},
      {fr:'Chaise de collectivité et restauration', en:"Community and restaurant chair"},
      {fr: 'Gerbeur', en: "Stacker"},
      {fr:'Mobilier scolaire', en:"School furniture"},
      {fr:'Siège de bureau', en:"Office chair"},
      {fr: 'Siège de bureau premium', en:'Premium office chair'},
      {fr:"Siège d'accueil et de réunion (empilable)", en:"Stackable meeting/reception chair"},
      {fr:"Siège d'accueil et de réunion (non empilable)", en:"Non-stackable meeting/reception chair'"},
      {fr:'Table de restauration et de collectivité', en:"Community and restaurant table"},
      {fr:"Table de réunion et d'accueil", en:"Meeting/reception table"},
      {fr:"Table de réunion et d'accueil pliante", en:"Folding meeting/reception table"},
      {fr:'Vestiaire monocase', en:"Single locker"},
      {fr:'Vestiaire monocase 1 colonne industrie propre', en:"Single locker 1 column clean industry"},
      {fr:'Vestiaire monocase 1 colonne  industrie salissante', en:"Single locker 1 column dirty industry"},
      {fr:'Vestiaire monocase 2 colonnes industrie propre', en:"Single locker 2 columns clean industry"},
      {fr:'Vestiaire monocase 2 colonnes industrie salissante', en:"Single locker 2 columns dirty industry"},
      {fr:'Vestiaire monocase 3 colonnes industrie propre', en:"Single locker 3 columns clean industry"},
      {fr:'Vestiaire monocase 3 colonnes industrie salissante', en:"Single locker 3 columns dirty industry"},
      {fr:'Vestiaire monocase de bureau', en:"Office single locker"},
      {fr:'Vestiaire multicases', en:"Multi-locker"},
      {fr:'Vestiaire multicases 1 colonne', en:"Multi-locker 1 column"},
      {fr:'Vestiaire multicases 2 colonnes', en:"Multi-locker 2 columns"},
      {fr:'Vestiaire multicases 3 colonnes', en:"Multi-locker 3 columns"}
]

// Liste des langues disponibles pour le dropdown (code, label, emoji)
export const availableLanguages = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' }
];

interface LangContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const LangContext = createContext<LangContextType>({ lang: 'fr', setLang: () => {} });

export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }: { children: React.ReactNode }) => {
  const [lang, setLang] = useState<Lang>('fr');
  const setLangSafe = (l: Lang) => setLang(l);
  const value = useMemo(() => ({ lang, setLang: setLangSafe }), [lang]);
  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
};
